import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import { Card, Carousel, Col, ListGroup, Row } from "react-bootstrap";
import PsContext from "../../../context";

import { ServiceUrl } from "../../../utils/serviceUrl";
import { getFileLiveUrl, LOADER_LOGO, upperCase } from "../../../utils";
import NO_PHOTO from "../../../assets/img/no_photo.jpeg";

const FaulctyList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const deptId = props.match.params.id;
  const [dataList, setDataList] = useState([]);

  const userPhoto = (gen) => {
    let gender = upperCase(gen);
    return NO_PHOTO;
  };

  useEffect(() => {
    setDataList([]);
    loadData();
  }, [props.pageId]);

  const loadData = () => {
    setLoader(true);

    axios
      .get(ServiceUrl.DEPT.FACULTY + "?academic_department=" + deptId)
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {dataList.length > 0 && (
        <div>
          <h4 className="text-center mb-4">Faculty</h4>
          <table className="table table-bordered table-hover">
            <thead>
              <tr className="bg-light fw-bold">
                <th width="60" className="fw-bold">
                  S.No
                </th>
                <th className="fw-bold">Name of the Faculty</th>
                <th width="160" className="fw-bold">
                  Photo
                </th>
              </tr>
            </thead>
            <tbody>
              {dataList.map((item, i) => {
                return (
                  <tr key={i}>
                    <td align="center">{i + 1}</td>
                    <td>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                          fontFamily: "Segoe Ui",
                        }}
                      >
                        {item.emp_prefix} {item.emp_name}
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          lineHeight: "25px",
                          marginTop: "15px",
                        }}
                      >
                        {item.emp_qualification}
                        <br />
                        {item.emp_personal_mail}
                        <br />
                        {/* <span>Vidwan id: <a target="_blank" href={item.vidwan_link}>{item.vidwan_id}</a></span> */}
                        {item.vidwan_id ? (
                          <span>
                            Vidwan ID:{" "}
                            <a target="_blank" href={item.vidwan_link}>
                              {item.vidwan_id}
                            </a>
                          </span>
                        ) : (
                          <span></span>
                        )}
                      </div>
                    </td>
                    <td align="center">
                      <img
                        // src={userPhoto(item.emp_gender)}
                        src={
                          item.emp_profile_photo
                            ? getFileLiveUrl(item.emp_profile_photo)
                            : userPhoto(item.emp_gender)
                        }
                        style={{ width: "120px" }}
                        className="shadow-sm"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default FaulctyList;
